import { ReactComponent as Icon } from 'assets/menuWide/icon-gc-shield.svg'
import React from 'react'

export default function HomeIcon(props: any) {
  return (
    <Icon {...props} />
  )
}